<template>
  <div
    id="off-canvas-wrap"
    class="off-canvas-wrap"
    data-offcanvas
  >
    <div class="inner-wrap">
      <div class="exit-off-canvas"/>
      <v-header/>
      <div
        id="main"
        role="main"
        class="my-arriva-zakelijk"
      >
        <div class="content">
          <div :class="rowClasses">
            <div class="inner">
              <navigation v-if="showNavigation"/>
              <slot/>
            </div>
          </div>
        </div>
      </div>
      <v-footer/>
    </div>
  </div>
</template>

<script>
import VHeader from '../components/Header'
import VFooter from '../components/Footer'
import VLoader from '../components/Loader'
import Navigation from '../components/Navigation'

export default {
  name: 'LayoutDefault',
  components: {
    VHeader,
    VFooter,
    VLoader,
    Navigation
  },
  props: {
    rowClasses: {
      type: Array,
      default: () => ['row']
    },
    showNavigation: {
      type: Boolean,
      required: false,
      default: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/Default.vue